/**
 * Filter option to be used with agTextColumnFilter in case of server-side
 * filtering.
 */
export const externalTextColumnFilter = {
  displayKey: 'external',
  displayName: 'Fetch filtered results',
  predicate: () => true,
};
